<!--
 * @Author: your name
 * @Date: 2022-04-27 09:35:26
 * @LastEditTime: 2025-03-17 10:00:31
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jzjy\src\views\ActiveCenter\index.vue
-->
<template>
  <div id="container">
    <main>
      <!-- 上半部分 -->
      <div class="top" >
        <div class="left">
          <h3>选择学科</h3>
          <div id="jcjx" class="tap" :class="{chosedtap:nowKm == 1}" @click="choseKm(1)">
            <span>CN</span>
            <p>语文</p>
          </div>
          <div id="jcjx" class="tap" :class="{chosedtap:nowKm == 3}" @click="choseKm(3)">
            <span>EN</span>
            <p>英语</p>
          </div>
        </div>
        <div class="lunbo">
          <el-carousel
            indicator-position="none"
            height="240px"
            arrow="always"
            :autoplay="false"
          >
            <el-carousel-item v-for="item in bannerLists" :key="item.id">
              <img :src="item.file_url" alt="" @click="advert(item.http_url)" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="right" v-if="login_status == 1" v-show="myList.length != 0">
          <div class="yyy">
            <img src="../../assets/img/5.0/newActive (9).png" alt="">
            <h3>已预约课程</h3>
          </div>
          <div class="acBox">
            <div class="acList" v-for="item in myList" :key="item.id" :class="{zhibo:item.zb_status == 2,weikaishi:item.zb_status == 1,yijiesu:item.zb_status == 2,}" @click="goActiveDetails(item.id,item.http_type,item.cs3)">
              <div class="zt zb" v-if="item.zb_status == 2"><img src="../../assets/img/5.0/newActive (10).png" alt=""><p>直播中</p></div>
              <div class="zt wks" v-if="item.zb_status == 1"><img src="../../assets/img/5.0/newActive (13).png" alt=""><p>未开始</p></div>
              <div class="zt yjs" v-if="item.zb_status == 3"><img src="../../assets/img/5.0/newActive (11).png" alt=""><p>已结束</p></div>
              <div class="msg">
                <div class="title">{{item.title}} 单元教学案例分析</div>
                <div class="time">时间：{{timeStamp2String(item.start_time * 1000, 2)}}（{{timeStamp2String(item.start_time * 1000, 11)}}）{{timeStamp2String(item.start_time * 1000, 5)}}</div>
              </div>
              <div class="caozuo" v-if="item.zb_status == 2" style="background: #F05659;">进入直播</div>
              <div class="caozuo" v-if="item.zb_status == 1" style="background: #1E60EB;">已预约</div>
              <div class="caozuo" v-if="item.zb_status == 3" style="background: #E6ECFA;color:#1E60EB;">查看回放</div>
            </div>
          </div>
        </div>
        <div class="right noClass" v-if="login_status == 1" v-show="myList.length == 0">
            <div class="yyy" style="margin-bottom:0;">
              <img src="../../assets/img/5.0/newActive (9).png" alt="">
              <h3>已预约课程</h3>
            </div>
            <img class="noact" src="../../assets/img/5.0/noClass.png" alt="">
          </div>
        <div class="noLogin" v-if="login_status != 1">
          <h3>您还没有登录，登录后可享更多体验！</h3>
          <div class="list">
            <div class="box" style="margin-left:18px">
              <img src="../../assets/img/5.0/newActive (6).png" alt="">
              <p>预约教研课程 </p>
            </div>
            <div class="box">
              <img src="../../assets/img/5.0/newActive (7).png" alt="">
              <p>观看历史记录</p>
            </div>
            <div class="box">
              <img src="../../assets/img/5.0/newActive (8).png" alt="">
              <p>多终端同步学习  </p>
            </div>
          </div>
          <div class="goLogin" @click="goLogin">
            立即登录
          </div>
        </div>
      </div>
      <!-- 直播预告 -->
      <div class="jyactive" v-if="ygShow">
        <div class="boxtitle">
          <div class="left">
            <!-- <h4>专题教研课</h4> -->
          </div>
          <!-- <div class="right" @click="goActiveCenter(401)">查看更多</div> -->
        </div>
        <div class="activeList">
          <div class="zbyg" >
            <img src="../../assets/img/5.0/newActive (1).png" alt="" />
          </div>
          <div class="activeBox" v-for="item in ygList" :key="item.id"  @click="goActiveDetails(item.id,item.http_type,item.cs3)">
            <div class="tips" v-if="item.zb_status == 1"><p>预约中</p></div>
            <div class="tips" v-if="item.zb_status == 3"><p>查看回放</p></div>
            <div class="tips zbz" v-if="item.zb_status == 2"><img src="../../assets/img/5.0/newActive (10).png" alt=""><p>直播中</p></div>
            <div class="pic" >
              <img :src="item.file_url" />
            </div>
            <div class="activetitle">
              <p>{{ item.title }}</p>
            </div>
            <div class="teacherName" v-if="item.teacher_title">
              主讲专家：{{item.teacher_title}}
            </div>
            <div class="activetime">
              {{ timeStamp2String(item.start_time * 1000, 2) }}
              {{ timeStamp2String(item.start_time * 1000, 5) }}（{{
                timeStamp2String(item.start_time * 1000, 11)
              }}）
            </div>
            <div
              class="dosome bm"
              v-if="
                item.bm_status == 0 && new Date().getTime() < item.end_time * 1000
              "
            >
              立即预约
            </div>
            <div
              class="dosome bm"
              v-if="
                item.bm_status == 1 && new Date().getTime() < item.end_time * 1000
              "
            >
              已预约
            </div>
            <div
              class="dosome zhibo"
              style="background: #F05659;"
              v-if="
                item.bm_status == 1 &&
                new Date().getTime()> item.start_time * 1000
                 && new Date().getTime() <
                  item.end_time * 1000
              "
            >
              进入直播
            </div>
            <div
              class="dosome huifang"
              v-if="new Date().getTime() > item.end_time * 1000"
            >
              查看回放
            </div>
            <div
              class="dosome huifang"
              v-if="new Date().getTime() > item.end_time * 1000 && item.have_video == 0" 
            >
              暂无回放
            </div>
          </div>
          
        </div>
      </div>
      <!-- 专题教研课 -->
      <div class="jyactive" v-if="ztShow">
        <div class="boxtitle">
          <div class="left">
            <h4>专题教研课</h4>
          </div>
          <div class="right" @click="goActiveCenter(401)">查看更多</div>
        </div>
        <div class="activeList">
          <div
            class="activeBox"
            v-for="item in zbList"
            :key="item.id"
            @click="goActiveDetails(item.id,item.http_type,item.cs3)"
            style="margin-bottom:20px"
          >
            <div class="tips" v-if="item.zb_status == 1"><p>预约中</p></div>
            <div class="tips" v-if="item.zb_status == 3"><p>查看回放</p></div>
            <div class="tips zbz" v-if="item.zb_status == 2"><img src="../../assets/img/5.0/newActive (10).png" alt=""><p>直播中</p></div>
            <div class="pic">
              <img :src="item.file_url" />
            </div>
            <div class="activetitle">
              <p>{{ item.title }}</p>
            </div>
            <div class="teacherName" v-if="item.teacher_title">
              主讲专家：{{item.teacher_title}}
            </div>
            <div class="activetime">
              {{ timeStamp2String(item.start_time * 1000, 2) }}
              {{ timeStamp2String(item.start_time * 1000, 5) }}（{{
                timeStamp2String(item.start_time * 1000, 11)
              }}）
            </div>
            <div
              class="dosome bm"
              v-if="
                item.bm_status == 0 && new Date().getTime() < item.end_time * 1000
              "
            >
              立即预约
            </div>
            <div
              class="dosome bm"
              v-if="
                item.bm_status == 1 && new Date().getTime() < item.start_time * 1000
              "
            >
              已预约
            </div>
            <div
              class="dosome zhibo"
              style="background: #F05659;"
              v-if="
                item.bm_status == 1 &&
                new Date().getTime()> item.start_time * 1000
                 && new Date().getTime() <
                  item.end_time * 1000
              "
            >
              进入直播
            </div>
            <div
              class="dosome huifang"
              v-if="new Date().getTime() > item.end_time * 1000"
            >
              查看回放
            </div>
            <div
              class="dosome huifang"
              v-if="new Date().getTime() > item.end_time * 1000 && item.have_video == 0" 
            >
              暂无回放
            </div>
          </div>
          <div class="seemoreactive">
            <img src="../../assets/img/4.2/indexacpic.png" alt="" />
            <div class="gomoreactive" @click="goActiveCenter(401)">
              查看更多精彩活动
            </div>
          </div>
        </div>
      </div>
      <!-- 同步教研课 -->
      <div class="jyactive" v-if="tbShow">
        <div class="boxtitle">
          <div class="left">
            <h4>同步教研课</h4>
          </div>
          <div class="right" @click="goActiveCenter(402)">查看更多</div>
        </div>
        <div class="njChose">
          <div class="njtap" :class="{tapChosed:njTap == 0}" @click="choseNj(0)">全年级</div>
          <div class="njtap" :class="{tapChosed:njTap == 9}" @click="choseNj(9)">高一</div>
          <div class="njtap" :class="{tapChosed:njTap == 10}" @click="choseNj(10)">高二</div>
        </div>
        <div class="activeList">
          <div
            class="activeBox"
            v-for="item in hgList"
            :key="item.id"
            @click="goActiveDetails(item.id,item.http_type,item.cs3)"
            style="margin-bottom:20px"
          >
            <div class="tips" v-if="item.zb_status == 1"><p>预约中</p></div>
            <div class="tips" v-if="item.zb_status == 3"><p>查看回放</p></div>
            <div class="tips zbz" v-if="item.zb_status == 2"><img src="../../assets/img/5.0/newActive (10).png" alt=""><p>直播中</p></div>
            <div class="pic">
              <img :src="item.file_url" />
            </div>
            <div class="activetitle">
              <p>{{ item.title }}</p>
            </div>
            <div class="teacherName" v-if="item.teacher_title">
              主讲专家：{{item.teacher_title}}
            </div>
            <div class="activetime">
              {{ timeStamp2String(item.start_time * 1000, 2) }}
              {{ timeStamp2String(item.start_time * 1000, 5) }}（{{
                timeStamp2String(item.start_time * 1000, 11)
              }}）
            </div>
            <div
              class="dosome bm"
              v-if="
                item.bm_status == 0 && new Date().getTime() < item.end_time * 1000
              "
            >
              立即预约
            </div>
            <div
              class="dosome bm"
              v-if="
                item.bm_status == 1 && new Date().getTime() < item.start_time * 1000
              "
            >
              已预约
            </div>
            <div
              class="dosome zhibo"
              style="background: #F05659;"
              v-if="
                item.bm_status == 1 &&
                new Date().getTime()> item.start_time * 1000
                 && new Date().getTime() <
                  item.end_time * 1000
              "
            >
              进入直播
            </div>
            <div
              class="dosome huifang"
              v-if="new Date().getTime() > item.end_time * 1000"
            >
              查看回放
            </div>
            <div
              class="dosome huifang"
              v-if="new Date().getTime() > item.end_time * 1000 && item.have_video == 0" 
            >
              暂无回放
            </div>
          </div>
          <div class="seemoreactive">
            <img src="../../assets/img/4.2/indexacpic.png" alt="" />
            <div class="gomoreactive" @click="goActiveCenter(402)">
              查看更多精彩活动
            </div>
          </div>
        </div>
      </div>
      <!-- 报名时个人信息不完善，提交信息弹窗 -->
      <UserInfoBox
        v-if="userMsgShow"
        :yymsg="yymsg"
        @openSuccessTc="openSuccessTc"
      ></UserInfoBox>
      <!-- 预约成功弹窗 -->
      <YuyueBox
        v-if="signSuccess"
        :yymsg="yymsg"
        @closeYytc="closeYytc"
      ></YuyueBox>
    </main>
  </div>
</template>

<script>
import { timeStamp2String } from "../../utils/time";
import YuyueBox from "../../components/yuyueBox/yuyueBox.vue"; // vue2
import UserInfoBox from "../../components/userInfoBox/userInfoBox.vue"; // vue2
import {
  userinfo,
  list_teachers,
  banner,
  list_activityhdxd,
  activitytj_new,
  loc_kefuewm,
  bookslists,
  list_activityfl,
  activityindex_new,
  sjtj_hd,
  bm_activity,
  kemulists,
  versionslists,
  setnowkemu,
  list_zbhd,
  list_zbhd_index,
  islogin,
} from "../../api/http";
export default {
  inject: ["reload"],
  metaInfo () {
    return {
      title: '公益教研活动_教材同步教研课_专题专项教研课_高考复习备考指导课-精准教研教学平台',
       meta: [{ 
        name: 'Keywords',
        content: '公益教研活动,同步教研,教师培训,教师研修,在线教研,新高考'
      }, {
        name: 'description',
        content: '为切实推动高中新课改落地，精准教研教学平台专注提供公益教研活动服务，助力学校组织培训、精心打磨课程。教材同步教研课遵循国家新课标，紧密结合新教材，深入剖析知识点，帮助教师精准把握教学重点，优化教学方法。专题专项教研课及高考复习备考指导课，紧密围绕高考大纲和命题趋势，涵盖了全面系统的知识梳理、重点难点的深度剖析以及高效实用的备考策略。'
      }],
    }
  },
  data() {
    return {
      timeStamp2String,
      nowKm:1,//当前页面的科目，未登录默认语文
      timeNow: "", //当前时间的时间戳
      dialogVisibleTc: false, //预览的显示

      picMoveWidth: 0, //第一种图片位移距离

      //4.2版本迭代

      bannerLists: [], //banner列表
      teacherLists: [], //教师列表
      tcindex: "", //选中查看的教师下标
      showtcFile_url: "", //教师弹窗头像
      showtcTitle: "", //教师弹窗姓名
      showtcZhicheng: "", //教师弹窗简介
      showtcMsg: [], //教师弹窗介绍
      steep: 0, //教师列表移动
      steep1: 0, //教师评价移动速度
      steep2: 0, //活动图片移动速度


      file_url: "", //个人头像
      kejianversions_id: "", //版本id
      kemu_id: "", //科目
      nianji_id: "", //年级id

      njTap:0,
      

      yymsg: {}, //预约成功信息
      userMsgShow: false, //报名时完善信息弹窗
      signSuccess: false, //报名弹窗显示隐藏

      //切换学科
      radio1: "", //学科值
      radio2: "", //版本值
      topLeft: [],
      topList: [],
      myList:[],
      zbList: [],
      hgList: [],
      
      login_status:'',

      ygShow:false,
      ztShow:false,
      tbShow:false,
    };
  },
  components: {
    UserInfoBox,
    YuyueBox,
  },
  created() {
    //回到顶部
    $(document).ready(function () {
      $(window).scrollTop(0);
    });
    this.timeNow = Date.now();

    islogin({
      md5key: localStorage.getItem("md5key"),
    }).then(res=>{
      this.login_status = res.retRes.login_status;
      if(this.login_status == 1){
        //判断过期
        userinfo({
          md5key: localStorage.getItem("md5key"),
        }).then((res) => {
          // if (res.retRes.sy_end_time * 1000 < Date.parse(new Date())) {
          //   this.$router.push({
          //     name: "Login",
          //     query: {
          //       isgq: 1,
          //     },
          //   });
          // } else {
            const data = res.retRes;
            this.file_url = data.file_url;
            this.nowKm =  this.radio1 = this.kemu_id = data.kemu_id;
            this.kejianversions_id = data.kejianversions_id;
            this.nianji_id = data.nianji_id;
            this.getbanner(); //获取活动主页banner
            this.getLists();
          // }
        });
      }else{
        this.getbanner(); //获取活动主页banner
        this.getLists();
      }
    })
    
  },
  mounted() {
    console.log(new Date().getTime())
    //重定向
    localStorage.setItem("path", "");
  },
  beforeDestroy() {
  },
  methods: {
    //前往登录
    goLogin(){
      this.$router.push({
        name: "Login",
      });
    },
    //获取
    getLists() {
      //已预约的活动
      list_zbhd({
        md5key: localStorage.getItem("md5key"),
        kemu_id:this.kemu_id?this.kemu_id:'',
        my: 1,
        page_size: 3,
      }).then((res) => {
        let data = res.retRes;
        this.myList = data
      });
      //直播预告
      list_zbhd({
        md5key: localStorage.getItem("md5key"),
        kemu_id:this.kemu_id?this.kemu_id:'',
        zb_status_arr:[1],
        // is_tj: 1,
        page_size: 3,
      }).then((res) => {
        let data = res.retRes;
          this.ygList = data
          if(res.retCounts == 0){
            this.ygShow = false
          }else{
            this.ygShow = true
          }
      });
      //专题教研课
      list_zbhd({
        md5key: localStorage.getItem("md5key"),
        kemu_id:this.kemu_id?this.kemu_id:'',
        jyjxtype_id:401,
        is_tj: 1,
        page_size: 7,
      }).then((res) => {
        let data = res.retRes;
          this.zbList = data
          if(res.retCounts == 0){
            this.ztShow = false
          }else{
            this.ztShow = true
          }
      });
      //同步教研课
      list_zbhd({
        md5key: localStorage.getItem("md5key"),
        kemu_id:this.kemu_id?this.kemu_id:'',
        jyjxtype_id:402,
        is_tj: 1,
        page_size: 7,
      }).then((res) => {
        let data = res.retRes;
          this.hgList = data
          if(res.retCounts == 0){
            this.tbShow = false
          }else{
            this.tbShow = true
          }
      });
    },
    choseKm(e){
      this.nowKm = this.kemu_id = e;
      this.getLists();
      this.getbanner(); //获取活动主页banner
    },
    choseNj(e){
      this.njTap = e
      if(e == 0){
        list_zbhd({
          md5key: localStorage.getItem("md5key"),
          kemu_id:this.kemu_id?this.kemu_id:'',
          jyjxtype_id:402,
          nianji_id:'',
          is_tj: 1,
          page_size: 7,
        }).then((res) => {
          let data = res.retRes;
            this.hgList = data
            if(res.retCounts == 0){
              this.tbShow = false
            }else{
              this.tbShow = true
            }
        });
      }else{
        list_zbhd({
          md5key: localStorage.getItem("md5key"),
          kemu_id:this.kemu_id?this.kemu_id:'',
          jyjxtype_id:402,
          nianji_id:this.njTap,
          is_tj: 1,
          page_size: 7,
        }).then((res) => {
          let data = res.retRes;
            this.hgList = data
            if(res.retCounts == 0){
              this.tbShow = false
            }else{
              this.tbShow = true
            }
        });
      }
    },
    //跳转广告图
    advert(href, id) {
      window.open(href, "_blank");
    },
    openSuccessTc() {
      kemulists({
        md5key: localStorage.getItem("md5key"),
      }).then((res) => {
        res.retRes.forEach((item) => {
          if (this.kemu_id == item.id) {
            this.yymsg.file_url = item.gzh_file_url;
            this.yymsg.kemu_id = this.kemu_id;
            this.signSuccess = true;
          }
        });
      });
    },
    //关闭弹窗
    closeYytc() {
      this.signSuccess = false;
      // this.getActives();
    },
    //获取活动主页banner
    getbanner() {
      banner({
        md5key: localStorage.getItem("md5key"),
        systypes_id: 10003,
        device_type_id: 201,
        kemu_ids:this.kemu_id,
      }).then((res) => {
        console.log(res, "活动主页banner");
        this.bannerLists = res.retRes;
      });
    },
    //展示教师信息
    showTeacher(index) {
      this.tcindex = index;
      this.dialogVisibleTc = true;
      this.showtcFile_url = this.teacherLists[this.tcindex].file_url;
      this.showtcTitle = this.teacherLists[this.tcindex].title;
      this.showtcZhicheng = this.teacherLists[this.tcindex].zhicheng;
      const msg = this.teacherLists[this.tcindex].sub_title;
      msg.replace(";", "；"); //替换可能存在的英文分号为中文分号
      this.showtcMsg = msg.split("；"); //根据中文分号分隔文字为数组
    },
    //弹窗上一位老师
    preTc() {
      this.tcindex--;
      this.showtcFile_url = this.teacherLists[this.tcindex].file_url;
      this.showtcTitle = this.teacherLists[this.tcindex].title;
      this.showtcZhicheng = this.teacherLists[this.tcindex].zhicheng;
      const msg = this.teacherLists[this.tcindex].sub_title;
      msg.replace(";", "；"); //替换可能存在的英文分号为中文分号
      this.showtcMsg = msg.split("；"); //根据中文分号分隔文字为数组
    },
    //弹窗下一位老师
    nextTc() {
      this.tcindex++;
      this.showtcFile_url = this.teacherLists[this.tcindex].file_url;
      this.showtcTitle = this.teacherLists[this.tcindex].title;
      this.showtcZhicheng = this.teacherLists[this.tcindex].zhicheng;
      const msg = this.teacherLists[this.tcindex].sub_title;
      msg.replace(";", "；"); //替换可能存在的英文分号为中文分号
      this.showtcMsg = msg.split("；"); //根据中文分号分隔文字为数组
    },
    //报名 预约
    baoming(id, title) {
      this.yymsg.title = title;
      this.yymsg.active_id = id;
      //获取用户信息用于报名
      userinfo({
        md5key: localStorage.getItem("md5key"),
      }).then((res) => {
        if (res.retInt == 1) {
          console.log(res);
          const data = res.retRes;
          if (data.jbxx_set == 0) {
            this.userMsgShow = true;
          } else {
            bm_activity({
              md5key: localStorage.getItem("md5key"),
              activity_id: id,
              school_id: data.school_id,
              kemu_id: data.kemu_id,
              nianji_id: data.nianji_id,
              zhiwu_id: data.zhiwu_id,
              is_bzr: JSON.stringify(data.is_bzr),
              title: this.title,
              true_name: data.true_name,
              account: data.account,
              provincecode: data.provincecode,
              citycode: data.citycode,
              areacode: data.areacode,
            }).then((res) => {
              if (res.retInt == 1) {
                console.log(res, "报名成功");

                kemulists({
                  md5key: localStorage.getItem("md5key"),
                }).then((res) => {
                  res.retRes.forEach((item) => {
                    if (this.kemu_id == item.id) {
                      this.yymsg.file_url = item.gzh_file_url;
                      this.yymsg.kemu_id = this.kemu_id;
                      this.signSuccess = true;
                    }
                  });
                });

                // this.reload();
              }
            });
          }
        }
      });
    },
    //去活动详情
    goActiveDetails(id, type,url) {
      if(type == 1){
        let { href } = this.$router.resolve({
          path: "/active/fullScreen",
          query: {
            id: id,
            type: 'hd',
            from: "教研直播",
          },
        });
        window.open(href, "activeRes");
      }else{
        let href = url
        window.open(href, "activeRes");
      }
      
    },
    //点击查看更多去全部活动列表
    goAllAcList(e) {
      this.$router.push({
        name: "SeeMoreActive",
        query: {
          typeTitle: "全部",
          type: "all",
          zb_status:e,
        },
      });
    },
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },

    goActiveCenter(e) {
      this.$router.push({
        name: "SeeMoreActive",
        query: {
          typeTitle: "全部",
          jyjxtype_id:e,
        },
      });
    },
  },
};
</script>
<style>
.el-dialog__headerbtn {
  /* color: #1E60EB; */
  position: absolute;
  top: 20px;
  right: 40px;
  width: 0;
  height: 0;
}
.el-dialog__headerbtn .el-dialog__close:hover {
  color: #1E60EB;
}
</style>
<style lang="less" scoped>
#container {
  background-color: #f0f2f5;
  main {
    margin: 0 auto;
    margin-top: 20px;
    width: 1200px;
    background-color: #f0f2f5;
    .top {
      position: relative;
      display: flex;
      .left {
        display: flex;
        flex-direction: column;
        width: 180px;
        height: 240px;
        background: #ffffff;
        border-radius: 10px 0px 0px 10px;
        opacity: 1;
        h3{
          margin: 20px;
          font-size: 16px;color: #333333;
        }
        .tap {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 20px;
          width: 140px;
          height: 54px;
          // background: #E6ECFA;
          border-radius: 10px;
          font-weight: 600;
          font-size: 16px;
          cursor: pointer;
          color: #333;
          span{
            margin-right: 10px;
            width: 22px;
            height: 18px;
            background: #F5F5F5;
            border-radius: 3px;
            color: #CCCCCC;
            font-size:12px;
            text-align: center;
            line-height: 18px;
          }
        }
        .chosedtap {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 20px;
          width: 140px;
          height: 54px;
          background: #E6ECFA;
          border-radius: 10px;
          font-weight: 600;
          font-size: 16px;
          cursor: pointer;
          color: #1E60EB;
          span{
            margin-right: 10px;
            width: 22px;
            height: 18px;
            background: #1E60EB;
            border-radius: 3px;
            color: #FFF;
            font-size:12px;
            text-align: center;
            line-height: 18px;
          }
        }
      }
      .lunbo {
        // margin-left: 21px;
        width: 540px;
        height: 240px;
        border-radius: 10px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
      .noActive {
        width: 540px;
        img {
          width: 540px;
        }
      }
      .right {
        padding-left: 20px;
        width: 480px;
        height: 240px;
        background: #FFFFFF;
        .yyy{
          display: flex;
          align-items: center;
          margin-top: 20px;
          margin-bottom: 16px;
          img{
            margin-right: 5px;
            width: 20px;
            height: 16px;
            // background: #0B53FD;
          }
          h3{
            font-size: 16px;
            color: #333333;
          }
        }
        .acBox{
          .acList{
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            width: 440px;
            height: 44px;
            background: #FFFFFF;
            border-radius: 4px;
            border: 1px solid #E6E6E6;
            cursor: pointer;
            .zt{
              display: flex;
              justify-content: center;
              align-items: center;
              width: 80px;
              height: 44px;
              color: #666;
              border-radius: 2px 4px 4px 2px;
              border-right: 1px solid #E6E6E6;
              img{
                margin-right: 6px;
                width: 12px;
                height: 12px;
              }
            }
            .msg{
              display: flex;
              flex-direction: column;
              margin-left: 10px;
              width: 230px;
              .title{
                font-size: 14px;
                color: #666666;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .time{
                font-size: 12px;
                color: #999999;
              }
            }
            .caozuo{
              margin-left: 28px;
              width: 80px;
              height: 28px;
              background: #1E60EB;
              line-height: 28px;
              border-radius: 14px;
              text-align: center;
              color: #FFF;
            }
          }
          .zb{
              background: #f05659 ;
              color: #FFFFFF !important;
            }
          .wks{
            background: #1E60EB ;
            color: #FFFFFF !important;
          }
          .yjs{
            background: #F4F4F4;
            color: #333 !important;
          }
          .zhibo{
            background: #fbeced;
            border: 1px solid #f05659;
            .msg{
              .title{
                color: #f05659;
              }
              .time{
                color: #f05659;
              }
            }
          }
          .weikaishi{
            background: #E6ECFA;
            border: 1px solid #1E60EB;
            .msg{
              .title{
                color: #1E60EB;
              }
              .time{
                color: #1E60EB;
              }
            }
          }
          .yijiesu{
            background: #FFF;
            border: 1px solid #E6E6E6;
            .msg{
              .title{
                color: #333;
              }
              .time{
                color: #333;
              }
            }
          }
        }
        h4{
          font-size: 16px;
          font-weight: 400;
          text-align: center;
          // margin-top: 48px;
          color: #666;
        }
      }
      .noClass{
        // background-image:url('../../assets/img/5.0/noClass.png') ;
        // background-size:80% ;
        // background-repeat: no-repeat;
        .noact{
          width: 80%;
          // margin-top: 20px;
          margin-left: 20px;
        }
      }
      .noLogin{
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        width: 480px;
        height: 240px;
        background: linear-gradient(70deg, #FFFFFF, #DCE6FA);
        h3{
          margin-top: 44px;
          font-size: 16px;
          color: #333333;
        }
        .list{
          display: flex;
          align-items: center;
          margin: 28px 0 30px 0;
          .box{
            display: flex;
            flex-direction: column;
            align-items: center;
            margin:  0 10px;
            img{
              width: 32px;
              height: 32px;
              border-radius: 50%;
            }
            p{
              font-size: 14px;
              color: #333333;
            }
          }
        }
        .goLogin{
          width: 100px;
          height: 32px;
          background: #1E60EB;
          border-radius: 16px;
          font-size: 14px;
          color: #FFFFFF;
          text-align: center;
          cursor: pointer;
          line-height: 32px;
        }
      }
    }
    .jyactive {
      margin: 0 auto;
      margin-top: 10px;
      margin-bottom: 20px;
      width: 1200px;
      background: #ffffff;
      border-radius: 10px;
      .boxtitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .left {
          margin: 19px;
          margin-bottom: 15px;
          h4 {
            margin-right: 5px;
            font-size: 18px;
            color: #333;
          }
        }
        .right {
          margin-right: 17px;
          font-size: 12px;
          color: #999;
          cursor: pointer;
        }
        .right:hover {
          color: #1E60EB;
        }
      }
      .njChose{
        display: flex;
        align-items: center;
        margin-left: 20px;
        .njtap{
          margin-bottom: 20px;
          margin-right: 30px;
          text-align: center;
          line-height: 30px;
          color: #666666;
          font-size: 14px;
          width: 88px;
          height: 30px;
          border-radius: 15px;
          border: 1px solid #DDDDDD;
          cursor: pointer;
        }
        .tapChosed{
          color: #FFFFFF;
          background: #1E60EB;
          border-radius: 15px;
        }
      }
      .activeList {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        padding-bottom: 20px;
        margin-left: 20px;
        .zbyg{
          margin-right: 20px;
          width: 275px;
          height: 246px;
          background: #ACC6FD;
          border-radius: 10px;
          img{
            width: 100%;
            height: 100%;
            border-radius: 10px;
          }
        }
        .activeBox {
          position: relative;
          margin-right: 20px;
          // margin-bottom: 20px;
          cursor: pointer;
          height: 246px;
          .tips{
            position: absolute;
            left: 10px;
            top: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60px;
            height: 20px;
            background: #000000;
            border-radius: 4px;
            opacity: 0.9;
            color: #FFFFFF;
            text-align: center;
            line-height: 20px;
            img{
              margin-right: 4px;
            }
          }
          .zbz{
            color: #FFFFFF;
            background: #F05659;
          }
          .pic {
            img {
              width: 275px;
              max-height: 146px;
              border-radius: 0px;
            }
          }
          .activetitle {
            margin-top: 4px;
            p {
              font-size: 14px;
              color: #333;
              width: 275px;
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2; // 控制多行的行数
              -webkit-box-orient: vertical;
            }
          }
          .teacherName{
            // position: absolute;
            // bottom: 20px;
            margin-top: 4px;
            font-size: 12px;
            color: #939599;
          }
          .activetime {
            position: absolute;
            bottom: 10px;
            font-size: 12px;
            color: #939599;
          }
          .dosome {
            position: absolute;
            bottom: 2px;
            right: 0;
            text-align: center;
            line-height: 28px;
            font-size: 12px;
            color: #fff;
            width: 80px;
            height: 28px;
            // background: #f05659;
            border-radius: 14px;
            cursor: pointer;
          }
          .bm {
            background: #1E60EB;
          }
          .zhibo {
            background: #1E60EB;
          }
          .huifang {
            background: #c4c7cc;
          }
        }
        .activeBox:hover {
          // transition: 1s;
          img {
            transition: 0.5s;
            // position: relative;
            // top: -10px;
            transform: translateY(-10px);
            box-shadow: 0px 2px 10px 2px #dedede;
          }
          .activetitle {
            transition: 0.5s;
            transform: translateY(-10px);
            p {
              color: #1E60EB;
            }
          }
          .teacherName{
            transition: 0.5s;
            transform: translateY(-10px);
          }
        }
        .seemoreactive {
          position: relative;
          // right: 20px;
          // position: absolute;
          margin-right: 20px;
          width: 275px;
          border-radius: 10px;
          overflow: hidden;
          img {
            width: 275px;
            border-radius: 10px;
          }
          .gomoreactive {
            position: absolute;
            left: 50%;
            bottom: 40px;
            transform: translateX(-50%);
            text-align: center;
            line-height: 40px;
            width: 200px;
            height: 40px;
            background: #1E60EB;
            border-radius: 6px;
            font-size: 12px;
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }
    .signSuccessBox {
      /deep/.el-dialog__header {
        padding: 0;
      }
      /deep/.el-dialog {
        border-radius: 20px;
      }
      /deep/.el-dialog__body {
        padding: 0;
      }
      /deep/.el-icon-close:before {
        color: #fff;
      }
      .top {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 320px;
        height: 240px;
        background-image: url("../../assets/img/bmsbg01.png");
        border-radius: 20px 20px 20px 20px;
        background-size: 100%;
        img {
          margin-top: 54px;
          text-align: center;
          width: 64px;
          height: 64px;
        }
        h3 {
          text-align: center;
          font-size: 20px;
          color: #ffffff;
          line-height: 72px;
        }
      }
      .signSuccessContent {
        overflow: hidden;
        h3 {
          margin: 25px auto;
          width: 320px;
          text-align: center;
          font-size: 20px;
          color: #f5484b;
        }
        .pic {
          margin: 0 auto;
          margin-bottom: 10px;
          width: 200px;
          height: 200px;
          border: 1px solid #dedede;
          img {
            width: 200px;
            height: 200px;
          }
        }
        p {
          margin-bottom: 15px;
          text-align: center;
          font-size: 16px;
          color: #969799;
        }
      }
    }
    .choseClass {
      /deep/.el-dialog {
        border-radius: 20px;
        height: 300px;
      }
      /deep/.el-dialog__header {
        padding: 0;
      }
      //首次弹出框的样式
      .chose {
        position: relative;
        margin-left: 40px;
        cursor: pointer;
        p {
          margin: 20px 0;
          margin-bottom: 20px;
          color: #646566;
        }
        .taps {
          display: flex;
          flex-wrap: wrap;
          .classRadio {
            display: flex;
            margin-right: 79px;
            .tips {
              position: relative;
              top: 2px;
              margin-right: 8px;
              width: 14px;
              height: 14px;
              border: 1px solid #cccccc;
              border-radius: 100%;
              line-height: 12px;
              text-align: center;
              span {
                display: inline-block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                width: 9px;
                height: 9px;
                background-color: #fff;
                border-radius: 100%;
              }
            }
            .tips2 {
              border: 1px solid #1E60EB;

              span {
                background-color: #1E60EB;
              }
            }
            p {
              margin: 0;
            }
          }
        }
        .tab2 {
          .classRadio {
            margin-bottom: 10px;
          }
        }
        .submitSet {
          position: absolute;
          right: 20px;
          bottom: -80px;
          width: 120px;
          height: 40px;
          background: #1E60EB;
          color: #fff;
          border-radius: 6px;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
